import memoize from "fast-memoize";
import React from "react";
import { Field } from "redux-form";
import TextAreaInput from "./TextAreaInput";
import isLength from "validator/lib/isLength";
import buildFormField from "./buildFormField";

const FormField = buildFormField(TextAreaInput, (input, meta, rest) => {
  return {
    ...input,
    autoComplete: "off",
    ...rest,
    invalid: `${meta.touched && (meta.invalid || rest.invalid)}`,
  };
});

// this needs to be memoizable!
const buildValidator = memoize((required, minSize, other) => {
  return [
    (value) => {
      if (required && !value) {
        return "required";
      }
      if (minSize && !isLength(value, minSize)) {
        return "minSize";
      }
      return undefined;
    },
  ].concat(other || []);
});

export default function TextAreaField(props) {
  // eslint-disable-next-line no-unused-vars
  const { required, type, validate, minSize, fluid, ...rest } = props;
  return (
    <Field
      {...rest}
      component={FormField}
      validate={buildValidator(required, Number(minSize), validate)}
    />
  );
}
